import Banner from "./Banner";
import Summary from "./Summary";
import Price from "./Price";
import { useLayoutEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

const ProductPage = () => {
	const { vin } = useParams();
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [trimValue, setTrimValue] = useState();
	// const [query] = useSearchParams();
	// let isSalvage = query.get("isSalvage");

	// Get car details from localStorage or location state
	const carDetail =
		location?.state?.selectedProduct ||
		JSON.parse(localStorage.getItem("selectedProduct")) ||
		{};

	useLayoutEffect(() => {
		window.scroll(0, 0);
	}, []);

	return (
		<div className="product-page">
			<Banner carDetail={carDetail} />
			<Summary
				vin={vin}
				loading={loading}
				setLoading={setLoading}
				trimValue={trimValue}
				carDetail={carDetail}
			/>
			<Price vin={vin} setLoader={setLoading} setTrimValue={setTrimValue} />
		</div>
	);
};

export default ProductPage;
